export default function CTASection() {
  return (
    <section
      id="download"
      className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20gradient%20of%20coral%20and%20amber%20tones%2C%20dreamy%20bokeh%20effect%2C%20warm%20golden%20light%20particles%20floating%2C%20modern%20minimal%20aesthetic%2C%20soft%20diffused%20glow%2C%20ethereal%20and%20inviting%20atmosphere%2C%20no%20text%2C%20abstract%20art%20photography&width=1920&height=800&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/40 via-foreground-900/30 to-foreground-900/50"></div>

      <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-3 tracking-wide uppercase">
          随时随地 一起吃瓜
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-2">
          下载51吃瓜app，第一时间获取最新爆料
        </p>
        <p className="text-sm md:text-base text-background-50/80 mb-6 md:mb-8">
          支持iOS和Android，完全免费
        </p>
        <a
          href="#"
          className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          <div className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-download-line text-background-50 text-xs"></i>
            </div>
          </div>
          <span>立即下载 App</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-sm"></i>
          </div>
        </a>
      </div>
    </section>
  );
}